module.exports = __webpack_public_path__ + "assets/EquilateralInCircleDetailed.5742052bdc7ef10b71983e63187ec73b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/EquilateralInCircleDetailed.png
// module id = 511
// module chunks = 0